import Footer from './Footer';
import MainBaoba from './Main/MainBaoba';

function Baoba( ) {
    
    return(

        <div>
            
            
            <MainBaoba />
            <Footer />
        </div>
        
    );
    
}
export default Baoba;